/**
 * @ngdoc directive
 * @name formcheckpassword
 *
 * @description
 * Page footer
 */
module.directive('formMessage', function () {
    'use strict';
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            type: '@'
        },
        template:
                '<div class="aqua-form--message-panel" ng-class="{\'is-alert\': type === \'alert\', \'is-info\': type === \'info\'}">' +
                '  <p class="aqua-form--messages grid grid-gutter grid-middle">' +
                '    <span class="aqua-form--messages--text" ng-transclude></span>' +
                '  </p>' +
                '</div>'
    };
});